import { useContext, useMemo } from 'react';
import { DevicesContext, DevicesContextData } from './context';

export function useDevices(companyId: string): DevicesContextData {
    const data = useContext<DevicesContextData | undefined>(DevicesContext);

    if (!data) {
        throw new Error(
            "DevicesContextData unavailable. Are you sure you're using this in a nested component of an DevicesProvider?"
        );
    }

    const _devices = useMemo(
        () => data.devices.filter((device) => device.companyId === companyId),
        [data.devices, companyId]
    );

    return {
        devices: _devices
    };
}
